module.exports = __webpack_public_path__ + "static/media/mascot-mark-dark.147ab8c4.svg";